import { profileApi } from "@/core/data/api";

export default async (value, query) => {
  return await profileApi.getProfile(value, query);
};
